import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import svgInline from '../SvgInline/SvgInline';
import { ViewerPrimaryColorUserStyle } from '../UserCustomization';
import buildingsIcon from './icon-buildings.png';
import sitesIcon from './icon-sites.png';
import areasIcon from './icon-areas.png';
import folderIcon from '../List/icon-folder.svg';
import searchIcon from './icon-search.svg';
import './Header.css';

export function HeaderComponent({
  areas,
  activeOnLoad,
  buildings,
  folder,
  handleSearchClick,
  hasFavorites,
  logoUrl,
  logoLink,
  pathname,
  search,
  searchType,
  sites,
  areaToShow,
  hideLogo,
  showSearchAndAppliedFilters,
}) {
  const buildingsActive = (pathname === '/' ? activeOnLoad === 'buildings' : /buildings/.test(pathname));
  const sitesActive = (pathname === '/' ? activeOnLoad === 'sites' : /sites/.test(pathname));
  const areasActive = (pathname === '/' ? activeOnLoad === 'areas' : /areas/.test(pathname));
  const favoritesActive = (pathname === '/' ? activeOnLoad === 'folder' : /favorites/.test(pathname));

  const hasLogo = logoUrl && hideLogo !== 1;
  const hasLogoLink = logoLink && hideLogo !== 1;

  return (
    <div className="header-wrapper">
      {hasLogo && !hasLogoLink && (
        <div className="header">
          <img src={logoUrl} alt="" />
        </div>
      )}
      {hasLogo && hasLogoLink && (
        <div className="header">
          <a href={logoLink} target="_new"><img src={logoUrl} alt="" /></a>
        </div>
      )}
      <div className={`main-nav ${!hasLogo ? 'no-logo' : ''}`}>
        {showSearchAndAppliedFilters && (<ViewerPrimaryColorUserStyle domStyle="backgroundColor">
          <a
            tabIndex="0" className="search btn search-icon hidden-xs"
            onClick={() => { handleSearchClick(searchType); }}
          >
            {svgInline(searchIcon)}
            Search
          </a>
        </ViewerPrimaryColorUserStyle>)}
        <ul>
          {buildings && (
            <li className={buildingsActive ? 'active' : ''}>
              <ViewerPrimaryColorUserStyle domStyle={buildingsActive && 'borderBottomColor'}>
                <Link
                  className="header__link"
                  to={{
                    pathname: '/buildings',
                    search,
                  }}
                >
                  <img src={buildingsIcon} width="28" height="27" alt="" /> Buildings
                </Link>
              </ViewerPrimaryColorUserStyle>
            </li>
          )}
          {sites && (
            <li className={sitesActive ? 'active' : ''}>
              <ViewerPrimaryColorUserStyle domStyle={sitesActive && 'borderBottomColor'}>
                <Link
                  className="header__link"
                  to={{
                    pathname: '/sites',
                    search,
                  }}
                >
                  <img src={sitesIcon} width="20" height="28" alt="" /> Sites
                </Link>
              </ViewerPrimaryColorUserStyle>
            </li>
          )}
          {areas && areaToShow && (
            <li className={areasActive ? 'active' : ''}>
              <ViewerPrimaryColorUserStyle domStyle={areasActive && 'borderBottomColor'}>
                <Link
                  className="header__link"
                  to={{
                    pathname: `/areas/${areaToShow}`,
                    search,
                  }}
                >
                  <img src={areasIcon} width="40" height="25" alt="" /> Areas
                </Link>
              </ViewerPrimaryColorUserStyle>
            </li>
          )}
          {folder && (
            <li className={favoritesActive ? 'active' : ''}>
              <ViewerPrimaryColorUserStyle domStyle={favoritesActive && 'borderBottomColor'}>
                <Link
                  className="header__link"
                  to={{
                    pathname: '/favorites',
                    search,
                  }}
                >
                  <div className={hasFavorites ? 'header__favorites-icon has-favorites' : 'header__favorites-icon'}>{svgInline(folderIcon)}</div> My Folders
                </Link>
              </ViewerPrimaryColorUserStyle>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}

HeaderComponent.propTypes = {
  areas: PropTypes.bool,
  activeOnLoad: PropTypes.string,
  buildings: PropTypes.bool,
  folder: PropTypes.bool,
  handleSearchClick: PropTypes.func.isRequired,
  hasFavorites: PropTypes.bool,
  logoUrl: PropTypes.string,
  logoLink: PropTypes.string,
  pathname: PropTypes.string,
  search: PropTypes.string,
  searchType: PropTypes.string,
  sites: PropTypes.bool,
  areaToShow: PropTypes.string,
  hideLogo: PropTypes.number,
  showSearchAndAppliedFilters: PropTypes.bool,
};

export default HeaderComponent;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js